// import Variables from './0-variables';
// import Utilities from './0-utilities';


export default {
    init() {
        // JavaScript to be fired on the about us page
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/about.js